import { FC } from "react";
import { IconProps } from "./types";

export const PauseIcon: FC<IconProps> = ({
  fill = "currentColor",
  width = 8,
  height = 10,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 8 10"
    fill="none"
    className={className}
    {...props}
  >
    <path d="M0 0H2.46154V9.84615H0V0Z" fill={fill} />
    <path d="M4.92308 0H7.38462V9.84615H4.92308V0Z" fill={fill} />
  </svg>
);
